// extracted by mini-css-extract-plugin
export var errorIcon = "_n1-1";
export var nameLogo = "_n1-0";